module.exports = __webpack_public_path__ + "media/src/images/welcomeLogo-377fa054ae3287edb740c12c50510074.png";